module.exports = "<div class=\"alert alert-success\"> <strong>Success!</strong> Your message has been successfully sent. </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/iframes/successBox.html
 ** module id = 2
 ** module chunks = 0
 **/